import './index.css';var be = Object.defineProperty;
var Te = (n, e, t) => e in n ? be(n, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : n[e] = t;
var m = (n, e, t) => Te(n, typeof e != "symbol" ? e + "" : e, t);
import { jsxs as D, jsx as d, Fragment as We } from "react/jsx-runtime";
import { ExpandDownLight as Ce, SearchLight as Ie, SortLight as Ae, VerticalCustom as we, WellClusterLightCustom as Ne, Status as Fe, UsersAltLight as Se, DrillingRigCustom as De, StarFill as Ee, StarLight as Le } from "@repo/go-icons";
import { Collapse as J, RadioGroup as Be, Tooltip as O, Loader as Re, RadioButtonGroup as q, Input as Ve, Button as U, Scrollbar as ke } from "@repo/go-ui";
import { observer as P } from "mobx-react-lite";
import { useRef as Ge, useMemo as z, useCallback as M, useEffect as ee } from "react";
import { initReactI18next as Oe, useTranslation as Q, I18nextProvider as Me } from "react-i18next";
import Pe from "i18next";
import Ke from "i18next-browser-languagedetector";
import { action as b, flow as oe, makeObservable as se, observable as T, computed as E } from "mobx";
var X = /* @__PURE__ */ ((n) => (n[n.ACTIVE_GREEN = 0] = "ACTIVE_GREEN", n[n.ACTIVE_YELLOW = 1] = "ACTIVE_YELLOW", n[n.ACTIVE_RED = 2] = "ACTIVE_RED", n[n.COMPLETED = 3] = "COMPLETED", n))(X || {});
const je = {
  ACTIVE_GREEN: "#219653",
  ACTIVE_YELLOW: "#F2C94C",
  ACTIVE_RED: "#EB5757",
  COMPLETED: "#ffffff80"
}, le = {
  block: {
    displayName: "abbreviatedName",
    order: null
  },
  field: {
    displayName: "abbreviatedName",
    order: 1
  },
  pad: {
    displayName: "abbreviatedName",
    order: 2
  }
}, He = { active: "Active", favorites: "Favorites", all: "All" }, $e = { alphabet: "Alphabetically", alphabetAsc: "From A to Z", alphabetDesc: "From Z to A", creationDate: "By creation date", creationDateAsc: "From oldest to newest", creationDateDesc: "From newest to oldest" }, ze = { status: "Status", rig: "Rig type", brigade: "Rig crew", location: "Well location", active: "Active", completed: "Completed" }, Xe = "Search", Ze = {
  filter: He,
  sorting: $e,
  grouping: ze,
  search: Xe
}, Qe = { list: Ze }, Ye = { active: "Activos", favorites: "Favoritos", all: "Todos" }, xe = { alphabet: "Por orden alfabético:", alphabetAsc: "De A a Z", alphabetDesc: "De Z a A", creationDate: "Por fecha de creación:", creationDateAsc: "De más antiguos a más nuevos", creationDateDesc: "De más nuevos a más antiguos" }, Je = { status: "Estado", rig: "Tipo de Rig", brigade: "Grupo de perforación", location: "Localizacion del Pozo", active: "Activos", completed: "Completado" }, qe = "Buscar", Ue = {
  filter: Ye,
  sorting: xe,
  grouping: Je,
  search: qe
}, et = { list: Ue }, tt = { active: "Активные", favorites: "Избранное", all: "Все" }, rt = { alphabet: "По алфавиту:", alphabetAsc: "От А до Я", alphabetDesc: "От Я до А", creationDate: "По дате создания:", creationDateAsc: "От поздних к новым", creationDateDesc: "От новых к поздним" }, ot = { status: "Статус", rig: "Буровая установка", brigade: "Буровая бригада", location: "Локация", active: "Активные", completed: "Законченные" }, st = "Поиск", lt = {
  filter: tt,
  sorting: rt,
  grouping: ot,
  search: st
}, at = { list: lt }, it = { ru: at, en: Qe, es: et }, nt = {
  caches: ["localStorage", "cookie"],
  lookupCookie: "i18next",
  lookupLocalStorage: "i18nextLng",
  lookupQuerystring: "lng",
  order: ["localStorage", "cookie", "querystring", "path"]
}, Y = Pe.createInstance();
Y.use(Ke).use(Oe).init({
  detection: nt,
  fallbackLng: "en",
  interpolation: {
    escapeValue: !1
  },
  react: {
    useSuspense: !0
  },
  resources: it
});
function ae(n) {
  var e, t, o = "";
  if (typeof n == "string" || typeof n == "number") o += n;
  else if (typeof n == "object") if (Array.isArray(n)) {
    var r = n.length;
    for (e = 0; e < r; e++) n[e] && (t = ae(n[e])) && (o && (o += " "), o += t);
  } else for (t in n) n[t] && (o && (o += " "), o += t);
  return o;
}
function ie() {
  for (var n, e, t = 0, o = "", r = arguments.length; t < r; t++) (n = arguments[t]) && (e = ae(n)) && (o && (o += " "), o += e);
  return o;
}
const ct = "well-collapse-module__wrapper__X87xE", ut = "well-collapse-module__list__tJ-jv", dt = "well-collapse-module__listItem__AIJLE", pt = "well-collapse-module__listItemActive__49M-4", gt = "well-collapse-module__titleWrapper__1fEIj", ht = "well-collapse-module__title__jvuSB", mt = "well-collapse-module__buttons__FhQEW", ft = "well-collapse-module__panelHeader__gDATX", yt = "well-collapse-module__panelHeaderArrow__bXR0E", _t = "well-collapse-module__panelHeaderArrowDown__JhZ-a", vt = "well-collapse-module__panelHeaderText__KIPhy", N = {
  wrapper: ct,
  list: ut,
  listItem: dt,
  listItemActive: pt,
  titleWrapper: gt,
  title: ht,
  buttons: mt,
  panelHeader: ft,
  panelHeaderArrow: yt,
  panelHeaderArrowDown: _t,
  panelHeaderText: vt
}, bt = P(function({
  well: e,
  renderIcon: t,
  onClick: o,
  renderButtons: r,
  refAt: s,
  isActive: l
}) {
  return /* @__PURE__ */ D("div", { className: ie(N.listItem, l && N.listItemActive), onClick: o, ref: s == null ? void 0 : s(e.id), children: [
    /* @__PURE__ */ D("div", { className: N.titleWrapper, children: [
      t == null ? void 0 : t(e),
      /* @__PURE__ */ d("p", { className: N.title, children: e.name })
    ] }),
    !!r && /* @__PURE__ */ d("div", { className: N.buttons, onClick: (a) => a.stopPropagation(), children: r() })
  ] });
}), Tt = P(function({
  groups: e,
  activeId: t,
  onItemSelect: o,
  refAt: r,
  renderButtons: s,
  activeKey: l,
  renderIcon: a,
  onChange: c
}) {
  const { t: v, i18n: C } = Q();
  return /* @__PURE__ */ d(J, { activeKeys: l, collapseClassname: N.wrapper, onChange: c, children: e.map((u) => {
    const p = C.exists(u.name) ? v(u.name) : u.name;
    return /* @__PURE__ */ d(
      J.Panel,
      {
        panelKey: u.id,
        header: /* @__PURE__ */ D("div", { className: N.panelHeader, children: [
          /* @__PURE__ */ d(
            Ce,
            {
              className: ie(N.panelHeaderArrow, l.includes(u.id) && N.panelHeaderArrowDown)
            }
          ),
          /* @__PURE__ */ d("p", { className: N.panelHeaderText, children: p })
        ] }),
        styleBody: { gridTemplateColumns: "100%" },
        children: /* @__PURE__ */ d("ul", { className: N.list, children: u.wells.map((W) => /* @__PURE__ */ d(
          bt,
          {
            renderIcon: a,
            renderButtons: s ? () => s(W) : void 0,
            refAt: r,
            isActive: t === W.id,
            well: W,
            onClick: () => o(W)
          },
          W.id
        )) })
      },
      u.id
    );
  }) });
}), Wt = "well-list-panel-body-module__wrapper__vRvNR", Ct = "well-list-panel-body-module__controlsWrapper__X91L0", It = "well-list-panel-body-module__sortButton__QsGlI", At = "well-list-panel-body-module__contentWrapper__YRcOU", wt = "well-list-panel-body-module__sortingTooltip__Wrapper__-fj95", Nt = "well-list-panel-body-module__sortingTooltip__optionsContainer__-WpHi", Ft = "well-list-panel-body-module__icon__Fez32", St = "well-list-panel-body-module__searchIcon__dfALD", Dt = "well-list-panel-body-module__switchContainer__RKQoM", Et = "well-list-panel-body-module__groupTypeContainer__TXn0N", Lt = "well-list-panel-body-module__groupTypeButton__ejLAz", Bt = "well-list-panel-body-module__groupTypeIcon__Bdyhq", Rt = "well-list-panel-body-module__activeIcon__vdUdB", Vt = "well-list-panel-body-module__iconButton__kfIvU", kt = "well-list-panel-body-module__drillingIcon__gZgce", Gt = "well-list-panel-body-module__loader__wOomF", y = {
  wrapper: Wt,
  controlsWrapper: Ct,
  sortButton: It,
  contentWrapper: At,
  sortingTooltip__Wrapper: wt,
  sortingTooltip__optionsContainer: Nt,
  icon: Ft,
  searchIcon: St,
  switchContainer: Dt,
  groupTypeContainer: Et,
  groupTypeButton: Lt,
  groupTypeIcon: Bt,
  activeIcon: Rt,
  iconButton: Vt,
  drillingIcon: kt,
  loader: Gt
}, Ot = P(function({ sorting: e, changeSorting: t }) {
  const o = Ge(null), { t: r } = Q("list"), s = z(() => [
    {
      name: r("sorting.alphabet"),
      items: [
        { label: r("sorting.alphabetAsc"), value: "nameAsc" },
        { label: r("sorting.alphabetDesc"), value: "nameDesc" }
      ]
    },
    {
      name: r("sorting.creationDate"),
      items: [
        {
          label: r("sorting.creationDateDesc"),
          value: "createdAtDesc"
        },
        {
          label: r("sorting.creationDateAsc"),
          value: "createdAtAsc"
        }
      ]
    }
  ], [r]);
  return /* @__PURE__ */ d("div", { className: y.sortingTooltip__Wrapper, ref: o, children: s.map((l) => /* @__PURE__ */ D("div", { className: y.sortingTooltip__optionsContainer, children: [
    /* @__PURE__ */ D("div", { children: [
      l.name,
      ":"
    ] }),
    /* @__PURE__ */ d(Be, { value: e, items: l.items, onChange: (a) => t(a) })
  ] }, l.name)) });
}), $ = {
  rig: /* @__PURE__ */ d(De, { className: y.groupTypeIcon }),
  brigade: /* @__PURE__ */ d(Se, { className: y.groupTypeIcon }),
  status: /* @__PURE__ */ d(Fe, { className: y.groupTypeIcon }),
  location: /* @__PURE__ */ d(Ne, { className: y.groupTypeIcon })
}, Mt = P(function({
  store: e,
  theme: t,
  language: o,
  refAt: r,
  extraWellButtons: s,
  onActiveKeysChange: l,
  onGroupingTypeChange: a,
  onSortingTypeChange: c,
  onSearchValueChange: v,
  onFilterTypeChange: C,
  onWellSelect: u
}) {
  const { t: p } = Q("list"), {
    searchValue: W,
    wellGroups: I,
    filterType: w,
    groupingType: F,
    sortingType: S,
    selectedWellId: A,
    activeKeys: K,
    isLoading: j,
    setSelectedWellId: H,
    setGroupingType: B,
    setSortingType: R,
    setFilterType: V,
    changeSearchValue: k,
    setActiveKeys: G,
    toggleFavorite: h,
    setCallbacks: x
  } = e, ue = (f) => {
    f.id !== A && H(f.id);
  }, de = z(() => [
    { label: p("filter.favorites"), value: "favorites" },
    { label: p("filter.active"), value: "active" },
    { label: p("filter.all"), value: "all" }
  ], [p]), pe = z(() => [
    { label: /* @__PURE__ */ d(O, { title: p("grouping.status"), children: $.status }), value: "status" },
    { label: /* @__PURE__ */ d(O, { title: p("grouping.rig"), children: $.rig }), value: "rig" },
    { label: /* @__PURE__ */ d(O, { title: p("grouping.brigade"), children: $.brigade }), value: "brigade" },
    { label: /* @__PURE__ */ d(O, { title: p("grouping.location"), children: $.location }), value: "location" }
  ], [p]), ge = (f, L) => {
    f.stopPropagation(), h(L);
  }, he = M(
    (f) => {
      V(f);
    },
    [V]
  ), me = M(
    (f) => {
      k(f);
    },
    [k]
  ), fe = M(
    (f) => {
      R(f);
    },
    [R]
  ), ye = M(
    (f) => {
      B(f);
    },
    [B]
  ), _e = M(
    (f) => {
      G(f);
    },
    [G]
  ), ve = (f) => /* @__PURE__ */ D(We, { children: [
    /* @__PURE__ */ d(
      U,
      {
        icon: e.isFavorite(f) ? /* @__PURE__ */ d(Ee, { className: y.activeIcon }) : /* @__PURE__ */ d(Le, { className: y.icon }),
        variant: "flat",
        onClick: (L) => ge(L, f),
        className: y.iconButton
      }
    ),
    s == null ? void 0 : s(f)
  ] });
  return ee(() => {
    x({
      onActiveKeysChange: l,
      onFilterTypeChange: C,
      onSortingTypeChange: c,
      onGroupingTypeChange: a,
      onSearchValueChange: v,
      onSelectWell: u
    });
  }, [
    l,
    C,
    a,
    v,
    c,
    u,
    x
  ]), ee(() => {
    Y.changeLanguage(o.language);
  }, [o.language, e]), /* @__PURE__ */ D("div", { className: y.wrapper, children: [
    j && /* @__PURE__ */ d(Re, { className: y.loader }),
    /* @__PURE__ */ D("div", { className: y.contentWrapper, children: [
      /* @__PURE__ */ d(
        q,
        {
          variant: "flat",
          items: de,
          value: w,
          className: y.switchContainer,
          itemClassName: y.switchButton,
          onChange: he
        }
      ),
      /* @__PURE__ */ D("div", { className: y.controlsWrapper, children: [
        /* @__PURE__ */ d(
          Ve,
          {
            allowClear: !0,
            prefix: /* @__PURE__ */ d(Ie, { className: y.searchIcon }),
            value: W,
            inputClassName: y.searchInput,
            placeholder: p("search"),
            onChange: (f) => me(f.target.value)
          }
        ),
        /* @__PURE__ */ d(
          O,
          {
            placement: "right",
            trigger: ["click"],
            title: /* @__PURE__ */ d(Ot, { sorting: S, changeSorting: fe }),
            children: /* @__PURE__ */ d(U, { icon: /* @__PURE__ */ d(Ae, { className: y.sortIcon }), className: y.sortButton })
          }
        )
      ] }),
      /* @__PURE__ */ d(ke, { children: /* @__PURE__ */ d(
        Tt,
        {
          renderIcon: (f) => {
            const L = f.status === "COMPLETED" && t === "light" ? "rgba(64, 81, 134, 1)" : je[f.status];
            return /* @__PURE__ */ d(we, { className: y.drillingIcon, style: { color: L != null ? L : "#ffffff80" } });
          },
          renderButtons: ve,
          groups: I,
          onItemSelect: ue,
          refAt: r,
          activeId: A != null ? A : void 0,
          activeKey: K,
          onChange: _e
        }
      ) })
    ] }),
    /* @__PURE__ */ d(
      q,
      {
        variant: "flat",
        items: pe,
        value: F,
        itemClassName: y.groupTypeButton,
        className: y.groupTypeContainer,
        onChange: ye
      }
    )
  ] });
}), er = P(function(e) {
  return /* @__PURE__ */ d(Me, { i18n: Y, children: /* @__PURE__ */ d(Mt, { ...e }) });
});
function Pt(n, e, t, o) {
  return new Promise((r, s) => {
    setTimeout(() => {
      r(e);
    }, n);
  });
}
class Kt {
  constructor(e) {
    m(this, "agent");
    this.agent = e;
  }
  async fetchWells() {
    return (await this.agent.get("wells")).data;
  }
}
var jt = Object.defineProperty, Ht = Object.getOwnPropertyDescriptor, i = (n, e, t, o) => {
  for (var r = o > 1 ? void 0 : o ? Ht(e, t) : e, s = n.length - 1, l; s >= 0; s--)
    (l = n[s]) && (r = (o ? l(e, t, r) : l(r)) || r);
  return o && r && jt(e, t, r), r;
};
const te = [
  "Common_Pad",
  "Common_Rig",
  "Common_Brigade",
  "Common_Block",
  "Common_Field",
  "Common_Organization",
  "Common_Rig_Model"
];
function ne(n) {
  return n < 0 ? -1 : n > 0 ? 1 : 0;
}
const ce = (n) => n === "COMPLETED" || n === "ACTIVE_RED";
class _ {
  constructor(e, t) {
    m(this, "store");
    m(this, "searchValue");
    m(this, "groupingType");
    m(this, "sortingType");
    m(this, "filterType");
    m(this, "selectedWellId");
    m(this, "activeKeys");
    m(this, "customFilter");
    m(this, "sortByStatus");
    m(this, "locationNameConfigurator");
    var o, r, s, l, a, c, v, C, u, p, W, I, w, F, S, A;
    this.store = e, this.sortingType = (r = (o = t == null ? void 0 : t.sortingType) != null ? o : e.sortingType) != null ? r : null, this.groupingType = (l = (s = t == null ? void 0 : t.groupingType) != null ? s : e.groupingType) != null ? l : null, this.filterType = (c = (a = t == null ? void 0 : t.filterType) != null ? a : e.filterType) != null ? c : null, this.selectedWellId = (C = (v = t == null ? void 0 : t.selectedWellId) != null ? v : e.selectedWellId) != null ? C : null, this.searchValue = (p = (u = t == null ? void 0 : t.searchValue) == null ? void 0 : u.trim()) != null ? p : "", this.activeKeys = (W = t == null ? void 0 : t.activeKeys) != null ? W : [], this.customFilter = (w = (I = t == null ? void 0 : t.customFilter) != null ? I : e.customFilterFn) != null ? w : "extend", this.sortByStatus = (F = t == null ? void 0 : t.sortByStatus) != null ? F : !1, this.locationNameConfigurator = (A = (S = t == null ? void 0 : t.locationNameConfigurator) != null ? S : e.locationNameConfigurator) != null ? A : le, se(this);
  }
  get filteredWells() {
    return this.allWells.filter((e) => {
      var t, o;
      if (this.searchValue && !e.name.includes(this.searchValue) || this.filterType && this.filterType === "active" && ce(e.status) || this.filterType && this.filterType === "favorites" && !this.store.favoritesService.wellIds.includes(e.id))
        return !1;
      if (this.customFilter)
        if (this.customFilter === "extend") {
          if (this.store.customFilterFn)
            return (o = (t = this.store).customFilterFn) == null ? void 0 : o.call(t, e);
        } else
          return this.customFilter(e);
      return !0;
    });
  }
  groupWells(e, t) {
    switch (e) {
      case "status": {
        const o = {};
        return t.forEach((r) => {
          const s = r.status.toLowerCase().includes("active") && r.status !== "ACTIVE_RED" ? "active" : "completed";
          o[s] ? o[s].wells.push(r) : o[s] = {
            id: s,
            wells: [r],
            status: s,
            type: "status",
            name: this.store.getStatusGroupName(s)
          };
        }), Object.values(o);
      }
      case "rig": {
        const o = {};
        return t.forEach((r) => {
          const s = r.rig, l = r.rigModel;
          if (!s) {
            console.error("cannot find rig for well", r.id, r.name);
            return;
          }
          if (!l) {
            console.error("cannot find rig model for well", r.id, r.name);
            return;
          }
          const a = s.id;
          o[a] ? o[a].wells.push(r) : o[a] = {
            id: a.toString(),
            wells: [r],
            rig: s,
            rigModel: l,
            type: "rig",
            name: this.store.getRigGroupName(s, l)
          };
        }), Object.values(o);
      }
      case "location": {
        const o = {};
        return t.forEach((r) => {
          const s = r.pad, l = r.block, a = r.field;
          if (!s || !l || !a) {
            console.error(
              "pad, block or field is missing for well",
              r.id,
              r.name,
              "pad",
              s,
              "block",
              l,
              "field",
              a
            );
            return;
          }
          const c = s.id;
          o[c] ? o[c].wells.push(r) : o[c] = {
            id: c.toString(),
            wells: [r],
            pad: s,
            block: l,
            field: a,
            type: "location",
            name: this.store.getLocationGroupName(l, a, s, this.store.locationNameConfigurator)
          };
        }), Object.values(o);
      }
      case "brigade": {
        const o = {};
        return t.forEach((r) => {
          const s = r.brigade;
          if (!s) {
            console.error("brigade is missing for well", r.id, r.name);
            return;
          }
          const l = s.id;
          o[l] ? o[l].wells.push(r) : o[l] = {
            id: l.toString(),
            wells: [r],
            brigade: s,
            type: "brigade",
            name: this.store.getBrigadeGroupName(s)
          };
        }), Object.values(o);
      }
    }
  }
  get allWells() {
    return this.store.allWells;
  }
  get wells() {
    const e = [];
    if (this.sortByStatus && e.push(re.sortByWellStatus), this.sortingType) {
      const t = this.sortingType;
      typeof t == "string" ? e.push((o, r) => re.sortBySortingType(o, r, t)) : e.push(t);
    }
    return e.length ? [...this.filteredWells].sort((t, o) => e.reduce((r, s, l) => {
      const a = -l;
      return r + Math.pow(ne(s(t, o)), a);
    }, 0)) : this.filteredWells;
  }
  get wellGroups() {
    return this.groupingType ? typeof this.groupingType != "function" ? this.groupWells(this.groupingType, this.wells) : this.groupingType(this.wells) : (console.warn("groupingType is not defined"), []);
  }
  setSearchValue(e) {
    var t;
    this.searchValue = (t = e == null ? void 0 : e.trim()) != null ? t : null;
  }
  setFilterType(e) {
    this.filterType = e;
  }
  setSortingType(e) {
    this.sortingType = e;
  }
  setGroupingType(e) {
    this.groupingType = e;
  }
  setSelectedWellId(e) {
    this.selectedWellId = e;
  }
  setActiveKeys(e) {
    this.activeKeys = e;
  }
  setCustomFilterFn(e) {
    e !== this.customFilter && (this.customFilter = e);
  }
  setLocationNameConfigurator(e) {
    this.locationNameConfigurator = e;
  }
}
i([
  T
], _.prototype, "searchValue", 2);
i([
  T
], _.prototype, "groupingType", 2);
i([
  T
], _.prototype, "sortingType", 2);
i([
  T
], _.prototype, "filterType", 2);
i([
  T
], _.prototype, "selectedWellId", 2);
i([
  T
], _.prototype, "activeKeys", 2);
i([
  T
], _.prototype, "customFilter", 2);
i([
  T
], _.prototype, "sortByStatus", 2);
i([
  T
], _.prototype, "locationNameConfigurator", 2);
i([
  E
], _.prototype, "filteredWells", 1);
i([
  E
], _.prototype, "allWells", 1);
i([
  E
], _.prototype, "wells", 1);
i([
  E
], _.prototype, "wellGroups", 1);
i([
  b.bound
], _.prototype, "setSearchValue", 1);
i([
  b.bound
], _.prototype, "setFilterType", 1);
i([
  b.bound
], _.prototype, "setSortingType", 1);
i([
  b.bound
], _.prototype, "setGroupingType", 1);
i([
  b.bound
], _.prototype, "setSelectedWellId", 1);
i([
  b.bound
], _.prototype, "setActiveKeys", 1);
i([
  b.bound
], _.prototype, "setCustomFilterFn", 1);
i([
  b.bound
], _.prototype, "setLocationNameConfigurator", 1);
const g = class Z {
  constructor(e, t, o, r) {
    m(this, "api");
    m(this, "directoriesService");
    m(this, "favoritesService");
    m(this, "locationNameConfigurator");
    m(this, "allWells", []);
    m(this, "searchValue");
    m(this, "groupingType");
    m(this, "sortingType");
    m(this, "filterType");
    m(this, "selectedWellId");
    m(this, "activeKeys");
    m(this, "isLoading", !1);
    m(this, "customFilterFn", null);
    m(this, "_callbacks", {});
    m(this, "valueAt");
    m(this, "clearRefs");
    m(this, "isFavorite", (e) => this.favoritesService.wellIds.includes(e.id));
    var s, l, a, c, v, C, u, p;
    this.api = (s = r == null ? void 0 : r.api) != null ? s : new Kt(e), this.directoriesService = t, this.favoritesService = o, this.sortingType = (l = r == null ? void 0 : r.defaultSortingType) != null ? l : "nameAsc", this.groupingType = (a = r == null ? void 0 : r.defaultGroupingType) != null ? a : "location", this.filterType = (c = r == null ? void 0 : r.defaultFilterType) != null ? c : "active", this.selectedWellId = (v = r == null ? void 0 : r.selectedWellId) != null ? v : null, this.searchValue = (C = r == null ? void 0 : r.searchValue) != null ? C : "", this.activeKeys = (u = r == null ? void 0 : r.activeKeys) != null ? u : [], this.locationNameConfigurator = (p = r == null ? void 0 : r.locationNameConfigurator) != null ? p : le, se(this);
  }
  enrichWellsWithDirectoriesData(e, t) {
    const o = [], [r, s, l, a, c, v, C] = te.map(
      (u, p) => {
        var W, I, w, F, S, A, K, j, H, B, R, V, k, G;
        switch (u) {
          case "Common_Pad":
            return new Map(
              (I = (W = t[p]) == null ? void 0 : W.map((h) => [h.id, { id: h.id, ...h.data }])) != null ? I : []
            );
          case "Common_Rig":
            return new Map(
              (F = (w = t[p]) == null ? void 0 : w.map((h) => [h.id, { id: h.id, ...h.data }])) != null ? F : []
            );
          case "Common_Brigade":
            return new Map(
              (A = (S = t[p]) == null ? void 0 : S.map((h) => [h.id, { id: h.id, ...h.data }])) != null ? A : []
            );
          case "Common_Rig_Model":
            return new Map(
              (j = (K = t[p]) == null ? void 0 : K.map((h) => [h.id, { id: h.id, ...h.data }])) != null ? j : []
            );
          case "Common_Organization":
            return new Map(
              (B = (H = t[p]) == null ? void 0 : H.map((h) => [h.id, { id: h.id, ...h.data }])) != null ? B : []
            );
          case "Common_Block":
            return new Map(
              (V = (R = t[p]) == null ? void 0 : R.map((h) => [h.id, { id: h.id, ...h.data }])) != null ? V : []
            );
          case "Common_Field":
            return new Map(
              (G = (k = t[p]) == null ? void 0 : k.map((h) => [h.id, { id: h.id, ...h.data }])) != null ? G : []
            );
        }
      }
    );
    return e.forEach((u) => {
      const p = r.get(u.padId);
      p || console.error("cannot find pad fow well", u.id, u.name);
      const W = p ? c.get(p.fieldId) : void 0;
      W || console.error("cannot find field fow well", u.id, u.name);
      const I = p ? a.get(p.blockId) : void 0;
      I || console.error("cannot find block fow well", u.id, u.name);
      const w = s.get(u.rigId);
      w || console.error("cannot find rig fow well", u.id, u.name);
      const F = w ? C.get(w.modelId) : void 0;
      F || console.error("cannot find rigModel fow well", u.id, u.name);
      const S = l.get(u.brigadeId);
      S || console.error("cannot find brigade fow well", u.id, u.name);
      const A = I ? v.get(I.organizationId) : void 0;
      A || console.error("cannot find organization fow well", u.id, u.name), o.push({
        ...u,
        pad: p,
        field: W,
        block: I,
        rig: w,
        rigModel: F,
        brigade: S,
        organization: A
      });
    }), o;
  }
  async enrichWellsData(e) {
    try {
      const [t, ...o] = await this.directoriesService.loadObjects([
        "GOdashboard_Well",
        ...te
      ]), r = (() => {
        const l = [], a = new Map(e.map((c) => [c.id, c]));
        return t == null || t.forEach((c) => {
          const v = a.get(c.id);
          v && l.push({
            ...v,
            ...c.data,
            createdAt: c.createdAt
          });
        }), l;
      })();
      return this.enrichWellsWithDirectoriesData(r, o);
    } catch (t) {
      return console.error(t), [];
    }
  }
  getStatusGroupName(e) {
    return e === "active" ? "list:grouping.active" : "list:grouping.completed";
  }
  getRigGroupName(e, t) {
    return `${t.name} ${e.rigNumber}`;
  }
  getBrigadeGroupName(e) {
    return e.name;
  }
  getLocationGroupName(e, t, o, r) {
    const s = {
      block: e,
      field: t,
      pad: o
    }, l = [];
    return Object.entries(r).filter(([a, c]) => !!c.order || c.order === 0).sort(([a, c], [v, C]) => c.order - C.order).forEach(([a, { displayName: c }]) => {
      const v = s[a][c];
      if (!v) {
        console.error(
          `${a} does not contain ${c}`,
          s[a]
        );
        return;
      }
      l.push(v.toString());
    }), l.join(" / ");
  }
  groupWells(e, t) {
    switch (e) {
      case "status": {
        const o = {};
        return t.forEach((r) => {
          const s = r.status.toLowerCase().includes("active") && r.status !== "ACTIVE_RED" ? "active" : "completed";
          o[s] ? o[s].wells.push(r) : o[s] = {
            id: s,
            wells: [r],
            status: s,
            type: "status",
            name: this.getStatusGroupName(s)
          };
        }), Object.values(o);
      }
      case "rig": {
        const o = {};
        return t.forEach((r) => {
          const s = r.rig, l = r.rigModel;
          if (!s) {
            console.error("cannot find rig for well", r.id, r.name);
            return;
          }
          if (!l) {
            console.error("cannot find rig model for well", r.id, r.name);
            return;
          }
          const a = s.id;
          o[a] ? o[a].wells.push(r) : o[a] = {
            id: a.toString(),
            wells: [r],
            rig: s,
            rigModel: l,
            type: "rig",
            name: this.getRigGroupName(s, l)
          };
        }), Object.values(o);
      }
      case "location": {
        const o = {};
        return t.forEach((r) => {
          const s = r.pad, l = r.block, a = r.field;
          if (!s || !l || !a) {
            console.error(
              "pad, block or field is missing for well",
              r.id,
              r.name,
              "pad",
              s,
              "block",
              l,
              "field",
              a
            );
            return;
          }
          const c = s.id;
          o[c] ? o[c].wells.push(r) : o[c] = {
            id: c.toString(),
            wells: [r],
            pad: s,
            block: l,
            field: a,
            type: "location",
            name: this.getLocationGroupName(l, a, s, this.locationNameConfigurator)
          };
        }), Object.values(o);
      }
      case "brigade": {
        const o = {};
        return t.forEach((r) => {
          const s = r.brigade;
          if (!s) {
            console.error("brigade is missing for well", r.id, r.name);
            return;
          }
          const l = s.id;
          o[l] ? o[l].wells.push(r) : o[l] = {
            id: l.toString(),
            wells: [r],
            brigade: s,
            type: "brigade",
            name: this.getBrigadeGroupName(s)
          };
        }), Object.values(o);
      }
    }
  }
  get filteredWells() {
    return this.allWells.filter((e) => !e.name.includes(this.searchValue) || this.filterType === "active" && ce(e.status) || this.filterType === "favorites" && !this.favoritesService.wellIds.includes(e.id) ? !1 : this.customFilterFn ? this.customFilterFn(e) : !0);
  }
  get wells() {
    return [...this.filteredWells].sort((e, t) => Z.sortByWellStatus(e, t) + ne(Z.sortBySortingType(e, t, this.sortingType)) / 10);
  }
  get wellGroups() {
    return this.groupWells(this.groupingType, this.wells);
  }
  get selectedWell() {
    var e;
    return (e = this.allWells.find((t) => t.id === this.selectedWellId)) != null ? e : null;
  }
  /**
   * Возвращает объект IWellSource, позволяющий получать отдельный (реактивный) список скважин с гибкой настройкой необходимых фильтров/сортировок/группировок.
   */
  getNewWellSourceInstance(e) {
    return new _(this, e);
  }
  setRefs(e, t) {
    var o;
    (o = this.clearRefs) == null || o.call(this), this.valueAt = e, this.clearRefs = t, this.selectedWellId && this.findAndScrollToWell(this.selectedWellId);
  }
  findAndScrollToWell(e) {
    let t = null;
    for (const o of this.wellGroups) {
      const r = o.wells.find((s) => s.id === e);
      if (r) {
        t = r;
        break;
      }
    }
    t && this.scrollWellIntoView(t.id);
  }
  async *scrollWellIntoView(e) {
    var s;
    const { group: t, selectedWell: o } = this.wellGroups.reduce(
      (l, a) => {
        const c = a.wells.find((v) => v.id === e);
        return c ? {
          selectedWell: c,
          group: a
        } : (l.group && l.selectedWell, l);
      },
      { selectedWell: null, group: null }
    );
    if (!t || !o)
      return;
    !this.activeKeys.includes(t.name) && Array.isArray(this.activeKeys) && (this.activeKeys.push(t.name), yield, await Pt(100), yield);
    const r = (s = this.valueAt) == null ? void 0 : s.call(this, o.id);
    r && r.scrollIntoView({ block: "nearest" });
  }
  setCallbacks(e) {
    this._callbacks = e;
  }
  setCustomFilterFn(e) {
    e !== this.customFilterFn && (this.customFilterFn = e);
  }
  toggleFavorite(e) {
    this.isFavorite(e) ? this.favoritesService.disableFavorite(e.id) : this.favoritesService.enableFavorite(e.id);
  }
  setLocationNameConfigurator(e) {
    this.locationNameConfigurator = e;
  }
  changeSearchValue(e) {
    var t, o;
    this.searchValue = e, (o = (t = this._callbacks).onSearchValueChange) == null || o.call(t, e);
  }
  setFilterType(e) {
    var t, o;
    this.filterType = e, (o = (t = this._callbacks).onFilterTypeChange) == null || o.call(t, e);
  }
  setSortingType(e) {
    var t, o;
    this.sortingType = e, (o = (t = this._callbacks).onSortingTypeChange) == null || o.call(t, e);
  }
  setGroupingType(e) {
    var t, o;
    this.groupingType = e, (o = (t = this._callbacks).onGroupingTypeChange) == null || o.call(t, e);
  }
  setSelectedWellId(e, t) {
    var r, s, l;
    this.selectedWellId = e;
    const o = (r = this.allWells.find((a) => a.id === this.selectedWellId)) != null ? r : null;
    (l = (s = this._callbacks).onSelectWell) == null || l.call(s, o, t);
  }
  setActiveKeys(e) {
    var t, o;
    this.activeKeys = e, (o = (t = this._callbacks).onActiveKeysChange) == null || o.call(t, e);
  }
  updateWellStatus(e, t) {
    const o = this.allWells.find((r) => r.id === e);
    if (!o) {
      console.error("cannot find corresponding well with wellId", e);
      return;
    }
    o.status = t;
  }
  async *fetchWells(e) {
    this.isLoading = !0;
    try {
      const t = await this.api.fetchWells();
      yield;
      const o = await this.enrichWellsData(t);
      return yield, this.allWells = o, o;
    } catch (t) {
      return yield, e && (e.hasError = !0), console.error(t), [];
    } finally {
      this.isLoading = !1;
    }
  }
  static sortBySortingType(e, t, o) {
    switch (o) {
      case "createdAtAsc":
        return e.createdAt - t.createdAt;
      case "createdAtDesc":
        return t.createdAt - e.createdAt;
      case "nameAsc":
        return e.name.localeCompare(t.name);
      case "nameDesc":
        return t.name.localeCompare(e.name);
    }
  }
  static sortByWellStatus(e, t) {
    return X[e.status] - X[t.status];
  }
};
i([
  T
], g.prototype, "locationNameConfigurator", 2);
i([
  T
], g.prototype, "allWells", 2);
i([
  T
], g.prototype, "searchValue", 2);
i([
  T
], g.prototype, "groupingType", 2);
i([
  T
], g.prototype, "sortingType", 2);
i([
  T
], g.prototype, "filterType", 2);
i([
  T
], g.prototype, "selectedWellId", 2);
i([
  T
], g.prototype, "activeKeys", 2);
i([
  T
], g.prototype, "isLoading", 2);
i([
  T
], g.prototype, "customFilterFn", 2);
i([
  T
], g.prototype, "_callbacks", 2);
i([
  E
], g.prototype, "filteredWells", 1);
i([
  E
], g.prototype, "wells", 1);
i([
  E
], g.prototype, "wellGroups", 1);
i([
  E
], g.prototype, "selectedWell", 1);
i([
  b.bound
], g.prototype, "findAndScrollToWell", 1);
i([
  oe.bound
], g.prototype, "scrollWellIntoView", 1);
i([
  b.bound
], g.prototype, "setCallbacks", 1);
i([
  b.bound
], g.prototype, "setCustomFilterFn", 1);
i([
  b.bound
], g.prototype, "toggleFavorite", 1);
i([
  b.bound
], g.prototype, "setLocationNameConfigurator", 1);
i([
  b.bound
], g.prototype, "changeSearchValue", 1);
i([
  b.bound
], g.prototype, "setFilterType", 1);
i([
  b.bound
], g.prototype, "setSortingType", 1);
i([
  b.bound
], g.prototype, "setGroupingType", 1);
i([
  b.bound
], g.prototype, "setSelectedWellId", 1);
i([
  b.bound
], g.prototype, "setActiveKeys", 1);
i([
  b.bound
], g.prototype, "updateWellStatus", 1);
i([
  oe.bound
], g.prototype, "fetchWells", 1);
let re = g;
export {
  X as WELL_STATUSES,
  je as WELL_STATUS_COLORS,
  er as WellListPanel,
  re as WellListPanelStore,
  le as defaultLocationNameConfigurator
};
//# sourceMappingURL=well-list.es.js.map
